module.exports = __webpack_public_path__ + "img/options-coloring.87371b10.svg";